<template>
  <base-header :type="gradientType" :class="headerClass">
    <slot></slot>
  </base-header>
</template>

<script>
export default {
  name: 'PageHeader',
  props: {
    gradientType: {
      type: String,
      default: 'gradient-green'
    },
    headerClass: {
      type: String,
      default: 'pb-6 pb-8 pt-5 pt-md-8'
    }
  }
};
</script>
